//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useProductFeedHealthOverviewQuery } from '@account-settings/accountSettingsQueries';
import { IProductFeedHealthOverviewResponse } from '@apis/product-feed-health/productFeedHealthApiModels';
import { ProductFeedHealthStatusType } from '@legacy-components/catalog/product-feed-health/product-feed-health-constants';
import { isUndefined } from '@utils/filterPredicates';
import {
  OnboardingStepInfo,
  OnboardingStepStatus,
} from '@welcome-page/constants/OnboardingConstants';

export const useOnboardingCatalogStepInfo = (): OnboardingStepInfo => {
  const selectStatus = ({ items }: IProductFeedHealthOverviewResponse) => {
    if (isUndefined(items) || items.length === 0) {
      return OnboardingStepStatus.INCOMPLETE;
    } else if (items.length === 1) {
      switch (items[0]?.status) {
        case ProductFeedHealthStatusType.PENDING:
        case ProductFeedHealthStatusType.NOT_ACQUIRED:
          return OnboardingStepStatus.PENDING;
        default:
          return OnboardingStepStatus.COMPLETE;
      }
    }

    return OnboardingStepStatus.COMPLETE;
  };

  const {
    data: status,
    isError,
    isLoading,
  } = useProductFeedHealthOverviewQuery(selectStatus);

  return {
    status: status ?? OnboardingStepStatus.INCOMPLETE,
    isError,
    isLoading,
  };
};
